module.exports = __webpack_public_path__ + "zl11-6dab86d4.png";